import { createFileRoute, redirect } from '@tanstack/react-router'
import { RegisterSuccess } from '@/pages/auth/register/RegisterSuccess'

export const Route = createFileRoute('/auth/success-register')({
  beforeLoad: ({ context }) => {
    if (context.authContext.isAuthenticated) {
      return redirect({
        to: '/home',
      })
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <RegisterSuccess />
}
